import React from 'react';
import { Fragment } from 'react';
import { UserPermissions } from '../services/Types';



const PermissionCheck = ({
  userPermissions,
  permissionToCheck,
  ...props
}: PermissionCheckProps): any => (
  <>
    {
      userPermissions.includes(permissionToCheck) &&
      <Fragment {...props}/>
    }
  </>
)

type PermissionCheckProps = {
  userPermissions: Array<UserPermissions>;
  permissionToCheck: UserPermissions;
  [key: string]: unknown;
}

export default PermissionCheck;